import { isInstrumentalPart } from './parts';

// The part names of songParts.json as they're said in Spanish. A name missing here is said as written.
const SPANISH_NAMES = {
  Intro: 'Intro',
  Verse: 'Verso',
  'Pre-chorus': 'Pre-coro',
  Chorus: 'Coro',
  Bridge: 'Puente',
  Music: 'Música',
  Instrumental: 'Instrumental',
  Outro: 'Final',
  Tag: 'Tag',
  Refrain: 'Estribillo',
};

const getTimes = (passes, lang) => {
  if (passes < 2) return '';
  if (lang === 'es') return passes === 2 ? 'dos veces' : `${passes} veces`;

  return passes === 2 ? 'twice' : `${passes} times`;
};

// "Piano", "Piano and Bass", "Walter, Ana and Luis"
const joinNames = (names, lang) => {
  const and = lang === 'es' ? 'y' : 'and';

  return names.length < 2 ? names.join('') : `${names.slice(0, -1).join(', ')} ${and} ${names[names.length - 1]}`;
};

/**
 * What is said a bar before a part comes in: its name and number, how many times it plays when it
 * repeats, and who it is for — the instruments of an instrumental part, the people assigned to any
 * other. "Verse 1, twice, Walter", "Intro 1, Piano", "Coro 2, 3 veces".
 *
 * @param {{name: string, number: number, instruments: string[], people: string[]}} entry - A run
 *   entry, see ChartRunContext
 * @param {number} passes - How many times the part plays in a row
 * @param {string} lang - 'en' or 'es', from getSpeechLang
 */
export const getPartCallout = ({ name, number, instruments = [], people = [] }, passes = 1, lang = 'en') => {
  const said = lang === 'es' ? SPANISH_NAMES[name] || name : name;
  const title = number ? `${said} ${number}` : said;
  const who = joinNames(isInstrumentalPart(name) ? instruments : people, lang);

  return [title, getTimes(passes, lang), who].filter(Boolean).join(', ');
};
